import React from 'react'
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import $ from 'jquery';
import { withRouter } from 'react-router-dom';
import {
  renderFieldNumeros, required
} from '../../util/inputs';

export class ModalImpressaoReciboPedido extends React.Component {
  // eslint-disable-next-line class-methods-use-this
  fecharModal () {
    $('#modalImpressaoReciboPedido')
      .modal('hide');
    $('#modalImpressaoReciboPedido')
      .hide();
    $('.modal-backdrop')
      .hide();
  }

  submit (values) {
    this.fecharModal();
    this.props.history.push(`/recibo-passagem?pedido=${values.numeroPedido}`)
  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;
    return (
      <div className="modal fade" id='modalImpressaoReciboPedido' role='dialog'
           aria-labelledby='modalImpressaoReciboPedido' aria-hidden='true' data-backdrop='static'>
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content" style={{borderRadius: '12px', overflow: 'hidden', border: 'none'}}>

            <div className="vx-modal-header">
              <div className="vx-modal-title">
                <span className="material-icons">receipt_long</span>
                Emitir Cupom / Recibo
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Fechar"
                      onClick={this.fecharModal.bind(this)}>
                <span className="material-icons">close</span>
              </button>
            </div>

            <form onSubmit={handleSubmit(this.submit.bind(this))}>
              <div className="vx-modal-body" style={{background: '#fff'}}>
                <div className="vx-modal-section">
                  <div className="vx-modal-section-title">
                    <span className="material-icons">tag</span>
                    Número do pedido
                  </div>
                  <Field name="numeroPedido" type="text" component={renderFieldNumeros}
                         validate={[required]} label="Número do pedido:"
                         css="form-control" readOnly={false}/>
                </div>
              </div>

              <div className="vx-modal-footer">
                <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal"
                        onClick={this.fecharModal.bind(this)}>
                  Cancelar
                </button>
                <button type="submit" disabled={invalid || submitting || pristine}
                        className="vx-modal-btn-confirmar">
                  <span className="material-icons" style={{fontSize: '16px'}}>print</span>
                  Imprimir
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(null, {})(reduxForm({
  form: 'formImpressaoRecibo',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(ModalImpressaoReciboPedido)));
